import { useTranslation } from "react-i18next";
import { SUPPORTED } from "@/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const cur = SUPPORTED.find((s) => s.code === i18n.language) || SUPPORTED.find((s) => s.code === i18n.language?.split("-")[0]) || SUPPORTED[0];

  return (
    <Select value={cur.code} onValueChange={(v) => i18n.changeLanguage(v)}>
      <SelectTrigger
        className={compact ? "h-9 w-[68px] rounded-full pl-2 pr-1 text-sm" : "h-10 w-[140px] rounded-full"}
        data-testid="language-switcher"
        aria-label="Language"
      >
        {compact ? (
          <span className="flex items-center gap-1"><Globe className="h-3.5 w-3.5" /><span className="uppercase text-xs">{cur.code}</span></span>
        ) : (
          <SelectValue />
        )}
      </SelectTrigger>
      <SelectContent className="bg-card">
        {SUPPORTED.map((s) => (
          <SelectItem key={s.code} value={s.code} data-testid={`lang-option-${s.code}`}>
            <span className="mr-2">{s.flag}</span>{s.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
